import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import { Link as RouterLink } from 'react-router-dom';

import { LoadingButton } from '@mui/lab';
import { Box, Grid, Link, Typography } from '@mui/material';

import { PasswordInput } from 'client/components/PasswordInput/PasswordInput';
import { RoutesEnum } from 'client/enums/routes.enum';
import useMFA from 'client/hooks/useMFA';

import { LoginParamsType } from '../../types/login-params.type';

export const ConfirmPasswordForm = (): React.ReactElement => {
  const { confirmMFA, loading } = useMFA();
  const { handleSubmit: validationSubmit, control } = useForm();

  const handleSubmit = (data: LoginParamsType) => {
    confirmMFA({
      code: data.code,
    });
  };

  return (
    <>
      <Typography component="h1" variant="h5">
        Two Factor Auth
      </Typography>
      <Typography component="span" variant="body1" align="justify">
        Enter your Code
      </Typography>
      <Box
        component="form"
        onSubmit={validationSubmit(handleSubmit)}
        sx={{ mt: 1 }}
        width={1}
      >
        <Controller
          name="code"
          control={control}
          render={({ field: { ref, ...rest } }) => (
            <PasswordInput
              {...rest}
              inputRef={ref}
              margin="normal"
              required
              fullWidth
              variant="outlined"
              label="Two Factor Code"
            />
          )}
        />
        <LoadingButton
          type="submit"
          loading={loading}
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
        >
          Send Code
        </LoadingButton>
        <Grid container>
          <Grid item>
            <Link component={RouterLink} to={RoutesEnum.Login} variant="body2">
              Sign in
            </Link>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default ConfirmPasswordForm;
